import { first } from "rxjs/operators";
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { AlertService } from "@app/_services";
import {
  LazyLoadEvent,
  MessageService,
  ConfirmationService,
} from "primeng/api";
import { MsgRecipient } from "../msg-recipient";
import { MsgRecipientService } from "../msg-recipient.service";
import { MsgRecipientComponent } from "../msg-recipient/msg-recipient.component";

@Component({
    selector: "app-msg-recipient-list",
    templateUrl: "./msg-recipient-list.component.html",
    styleUrls: ["./msg-recipient-list.component.css"],
    providers: [
        MessageService,
        ConfirmationService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
    // make column heading sticky
    styles: [
        `
      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
      }

      @media screen and (max-width: 64em) {
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
          top: 99px;
        }
      }
    `,
    ],
    standalone: false
})
export class MsgRecipientListComponent implements OnInit {
  constructor(
    private msgRecipientService: MsgRecipientService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dialog: MatDialog
  ) {
    // this.statuses = msgRecipientService.statuses
  }

  // data
  @Input() showFilter = true;
  @Input() showPagination = true;
  @Input() outlineNewButton = true;
  @Input() showAddRecipient = true;
  @Input() msgId ;
  msgRecipients: any;
  msgRecipient: MsgRecipient;
  @Output() recipientSelected = new EventEmitter<any>();
  selectedMsgRecipients: any[] = [];

  // paging
  first = 0;
  rows = 50;

  // list
  datasource: any;

  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];

  // forms
  formLoading = false;

  emailRecipientTypes: any;

  displayDateDialog: boolean = false;
  dateList: string[] = [];
  dateType: string = '';
  selectedRecipient?: any;

  columns: any[] = [
    { field: "msgRecipientId", header: "Recipient Id", width: "auto" },
    { field: "firstName", header: "First Name", width: "auto" },
    { field: "lastName", header: "Last Name", width: "auto" },
    { field: "email", header: "Email", width: "auto" },
    { field: "mobileNum", header: "Mobile Number", width: "auto" },
    { field: "mobileCountryCode", header: "Mobile Country Code", width: "auto" },
    { field: "emailRecipientType", header: "Type", width: "auto" },
    { field: "deferredDate", header: "Deferred", width: "auto" },
    { field: "deferredCount", header: "Deferred Count", width: "auto" },
    { field: "bouncedDate", header: "Bounced", width: "auto" },
    { field: "bouncedCount", header: "Bounced Count", width: "auto" },
    { field: "deliveredDate", header: "Delivered", width: "auto" },
    { field: "openedDate", header: "Opened", width: "auto" },
    { field: "openedCount", header: "Opened Count", width: "auto" },
    { field: "clickedDate", header: "Clicked", width: "auto" },
    { field: "clickedCount", header: "Clicked Count", width: "auto" },
    { field: "droppedDate", header: "Dropped", width: "auto" },
    { field: "unsubscribedDate", header: "Unsubscribed", width: "auto" },
  ];

  ngOnInit(): void {
    try {
      // default sort of list
      this.multiSortMeta = [];
      this.multiSortMeta.push({ field: "createDate", order: 0 });
      this.emailRecipientTypes = this.msgRecipientService.emailRecipientTypes;
      this.selectedMsgRecipients = [];
    } catch (error) {
      console.log("Error: " + error);
    }
  }

  showDates(recipient: any, type: 'Opened' | 'Clicked' | 'Bounced') {
  this.selectedRecipient = recipient;
  const datesString =
    type === 'Opened' ? recipient.openedDates :
    type === 'Clicked' ? recipient.clickedDates :
    recipient.bouncedDates;

  if (!datesString) return;

  this.dateList = datesString.split(',').filter(date => date.trim() !== '');
  this.dateType = type;
  this.displayDateDialog = true;
}

  checkSelected(msgRecipientId: any, event:any) {
    console.log("Selected recipientIds, msgRecipientId: " + msgRecipientId);
    console.log("event: ");
    console.log(event);
    if(this.selectedMsgRecipients.includes(msgRecipientId) && !event.checked) {
      this.selectedMsgRecipients.splice(this.selectedMsgRecipients.indexOf(msgRecipientId), 1);
    } else if(!this.selectedMsgRecipients.includes(msgRecipientId) && event.checked) {
      this.selectedMsgRecipients.push(msgRecipientId);
    }
    console.log("selectedMsgRecipients: ");
    console.log(this.selectedMsgRecipients);
    this.recipientSelected.emit(this.selectedMsgRecipients);
    // this.selectedMsgRecipients[msgRecipientId] = event.checked;
  }

  /*********
   * Delete Button
   *
   */
  onRowDelete(event: any) {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " + event.msgRecipientId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete(event);
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  /*********
   * Lazy Load All Data
   *
   */
  loadLazy(event: LazyLoadEvent) {
    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      console.log(
        " event.first:" +
          event.first +
          "  |  event.rows:" +
          event.rows +
          "  |  event.sortField:" +
          event.sortField +
          "  |  event.sortOrder:" +
          event.sortOrder +
          "  |  event.multiSortMeta:" +
          JSON.stringify(event.multiSortMeta) +
          "  |  event.globalFilter:" +
          event.globalFilter +
          "  |  event.filters:" +
          JSON.stringify(event.filters)
      );

      /*
       *
       * Default Sort
       */
      // https://stackoverflow.com/questions/679915/how-do-i-msgRecipient-for-an-empty-javascript-object
      // if we are NOT filtering and we are NOT sorting, apply a default sort
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: "createDate", order: -1 });
      }

      const pageNumber = Math.round(event.first / event.rows);
      if ( this.msgId){
        let msgIdFilter = { 'msgVO.msgId': { 'value': this.msgId, 'matchMode': 'in' } };
        Object.assign(event.filters, msgIdFilter);
      }
      this.msgRecipientService
        .findByFilter(
          pageNumber,
          event.rows,
          event.sortField,
          event.sortOrder,
          event.multiSortMeta,
          event.globalFilter,
          event.filters
        )
        .pipe(first())
        .subscribe(
          (res: any) => {
            this.datasource = res.data.reviews;
            this.recordTotal = res.page.recordTotal;
            this.msgRecipients = res.data.msgRecipients;
            console.log(JSON.stringify(res.page));
          },
          (err: any) => {
            console.log("reviews list error!: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.loading = false;
          }
        );

      if (this.datasource) {
        this.msgRecipients = this.datasource.slice(
          event.first,
          event.first + event.rows
        );
      }
    } catch (error) {
      console.log("loadLazy(" + event + ")" + error);
    }
  }

  getStatus() {
    return;
  }

  /*********
   * onRowSelect()
   * Used to handle row click (to edit, link, etc)
   */
  onRowSelect(event: any) {
    console.log("onRowSelect: " + JSON.stringify(event));
    this.onOpenFormEdit(event.data);
  }

  // handled in rate-bucket-form
  formAdd() {}

  /*********
   * formUpdate()
   * Used for row editing
   */
  formUpdate(msgRecipient: MsgRecipient) {
    try {
      this.formLoading = true;
      this.msgRecipientService.update(msgRecipient).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Update SUCCESS: " + JSON.stringify(res));
          this.msgRecipients.map((msgRecipient, i) => {
            if (
              msgRecipient.msgRecipientId ===
              res.data.msgRecipient.msgRecipientId
            ) {
              this.msgRecipients[i] = res.data.msgRecipient;
            }
          });
          // this.alertService.success(res, true);
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Update FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: JSON.stringify(err),
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * formDelete()
   * Used for row editing
   */
  formDelete(msgRecipient: any) {
    try {
      // stop here if form is invalid
      console.log("Delete Submitted: " + JSON.stringify(msgRecipient));

      this.formLoading = true;
      this.msgRecipientService.delete(msgRecipient.msgRecipientId).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Delete SUCCESS: " + JSON.stringify(res));
          this.msgRecipients.splice(
            this.msgRecipients.indexOf(msgRecipient),
            1
          );
          this.recordTotal = this.msgRecipients.length;
          this.messageService.add({
            severity: "success",
            summary: "Successful",
            detail: "MsgRecipient " + msgRecipient.msgRecipientId + " Deleted",
            life: 3000,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Delete  FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: "Delete Failed",
            detail:
              "MsgRecipient " +
              msgRecipient.msgRecipientId +
              " could not be deleted.  Be sure there are no assigned properties to this bucket.",
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * Add New Button
   *
   */
  onOpenFormAdd() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: "Add MsgRecipient",
      msgId : this.msgId
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(MsgRecipientComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.addMsgRecipientCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /*********
   * Edit Button
   *
   */
  onOpenFormEdit(msgRecipient: MsgRecipient) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      msgRecipient: msgRecipient,
      title: "Edit MsgRecipient",
      msgId: this.msgId
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(MsgRecipientComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.updateMsgRecipientCB(data);

      // close the dialogBox
      dialogRef.close();
    });

    dialogRef.componentInstance.doDelete.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.deleteMsgRecipientCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /**
   *
   * Dialog from Form Callbacks
   * To edit the list show add/edit/delete in real time from the popup form
   *
   */
  addMsgRecipientCB(msgRecipient: MsgRecipient) {
    console.log("Adding MsgRecipient: " + JSON.stringify(msgRecipient));
    // if we don't have a msgRecipients array yet...
    if (!this.msgRecipients) {
      this.msgRecipients = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.msgRecipients.unshift(msgRecipient);

    // no idea what this is but it is required to update the array
    this.msgRecipients = [...this.msgRecipients];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MsgRecipient " + msgRecipient.msgRecipientId + " Added",
      life: 3000,
    });
  }

  updateMsgRecipientCB(msgRecipient: MsgRecipient) {
    console.log("Updating MsgRecipient: " + JSON.stringify(msgRecipient));
    let itemIndex = this.msgRecipients.findIndex(
      (item: any) => item.msgRecipientId === msgRecipient.msgRecipientId
    );
    this.msgRecipients[itemIndex] = msgRecipient;

    // no idea what this is but it is required to update the array
    this.msgRecipients = [...this.msgRecipients];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MsgRecipient " + msgRecipient.msgRecipientId + " Updated",
      life: 3000,
    });
  }

  deleteMsgRecipientCB(msgRecipient: MsgRecipient) {
    console.log("Removing MsgRecipient: " + msgRecipient);
    this.msgRecipients.splice(this.msgRecipients.indexOf(msgRecipient), 1);
    this.recordTotal = this.msgRecipients.length;

    // no idea what this is but it is required to update the array
    this.msgRecipients = [...this.msgRecipients];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MsgRecipient " + msgRecipient.msgRecipientId + " Deleted",
      life: 3000,
    });
  }

  /**********
   *
   * PAGINATOR FUNCTIONS
   */
  next() {
    this.first = this.first + this.rows;
  }
  prev() {
    this.first = this.first - this.rows;
  }
  reset() {
    this.first = 0;
  }
  isLastPage(): boolean {
    return this.msgRecipients
      ? this.first === this.msgRecipients.length - this.rows
      : true;
  }
  isFirstPage(): boolean {
    return this.msgRecipients ? this.first === 0 : true;
  }

  get EmailRecipientTypes() {
    return this.emailRecipientTypes;
  }

  getEmailRecipientTypeNames(msgRecipient: any) {
    if (msgRecipient?.emailRecipientType) {
      const emailRecipientType = this.emailRecipientTypes.find(
        (e: any) => e.value == msgRecipient.emailRecipientType
      );
      return emailRecipientType.name;
    } else {
      return "";
    }
  }

  reloadPage() {
    window.location.reload();
  }

  showPaginator() {
    return true;
  }
}
